import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d9268376&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9268376')) {
      api.createRecord('d9268376', component.options)
    } else {
      api.reload('d9268376', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d9268376&", function () {
      api.rerender('d9268376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/comp/IncreaseNumber.vue"
export default component.exports